import admin from './admin.json';
import app from './app.json';
import auth from './auth.json';
import profile from './profile.json';
import ticket from './ticket.json';
import contract from './contract.json';
import library from './library.json';
import countries from './countries.json';
import identity from './identity.json';
import molecules from './molecules.json';
import filter from './filter.json';
import toast from './toast.json';
import packages from './packages.json';
import deposit from './deposit.json';
import enums from './enums.json';

const en = {
  admin,
  app,
  auth,
  profile,
  ticket,
  contract,
  library,
  countries,
  identity,
  molecules,
  filter,
  toast,
  packages,
  deposit,
  enums,
};

export default en;
